@if (emptyList()) {
  <ng-container *ngTemplateOutlet="empty" />
} @else {
  <app-table
    [columns]="tableColumnsService.visibleColumns()"
    [datas]="tableData()"
    [actions]="actions()"
    (columnsChange)="tableColumnsService.reorderColumns($event)"
    [skeletonCount]="skeletonCount()"
  />

  <app-paginator
    [isLoading]="!tableData()"
    [page]="coachingTableContentService.currentPage()"
    [totalItems]="coachingTableContentService.totalItems()"
    [itemsPerPage]="coachingTableContentService.contentLimitPerPage()"
    (nextPage)="coachingTableContentService.nextPage()"
    (previousPage)="coachingTableContentService.previousPage()"
    (goToPage)="coachingTableContentService.goToPage($event)"
    (setItemPerPage)="coachingTableContentService.setItemPerPage($event)"
    [firstItemInCurrentPage]="coachingTableContentService.firstItemInPage()"
    [lastItemInCurrentPage]="coachingTableContentService.lastItemInPage()"
    [lastPage]="coachingTableContentService.lastPage()"
  />
}

<ng-template #empty>
  <app-empty-content-list-element contentType="workout" />
</ng-template>
